import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ApiService } from 'app/core/services/api.service';
import { UtilService } from 'app/core/services/util.service';

@Component({
    selector: 'pause-dialog',
    templateUrl: './pause-dialog.component.html',
    styleUrls: [],
})
export class PauseDialogComponent implements OnInit {
    loading: boolean = false;
    @Input() activePage: 'campaign' | 'option' = 'campaign';
    currentPath: string;
    @Input() is_master_account : boolean = false;
    @Output() dataEvent = new EventEmitter<boolean>();

    constructor(
        public api: ApiService,
        private dialog: MatDialog,
        private util: UtilService,
        private router: Router
    ) {
        this.currentPath = window.location.pathname;
    }
    ngOnInit(): void {}
    pauseCampaign() {
      if (this.loading) true;
      this.loading = true;
      this.api.getData('pause-campaign/' + this.api.campaignId).subscribe({
          next: (res: any) => {
              if (res.success) {
                  this.loading = false;
                  if (this.activePage == 'campaign') {
                      this.api.allCampaign.forEach((campaign) => {
                          if (campaign.campaign_id == this.api.campaignId) {
                              campaign.status = 'Paused';
                          }
                      });
                      if (this.is_master_account) this.dataEvent.emit(true);
                  } else if (this.activePage == 'option') {
                      if (this.currentPath.includes('/campaign/all')) {
                          this.router.navigate(['/campaign']);
                      } else if (this.currentPath.includes('/campaign-builder')) {
                         this.router.navigate(['/campaign-builder'])
                      }
                  }
              } else {
                  this.util.showToast(res.message, true);
              }
              this.dialog.closeAll();
          },
          error: (err) => {
              console.log('error', err);
              this.loading = false;
          },
          complete() {},
      });
  }

}
